<unity-page-container contentHeader="Communities" [isLoading]="false">
  <ng-container page-return> <unity-action-shared [action]="returnToDashboardAction" /></ng-container>

  <ng-container notifications />

  <ng-container actions>
    <unity-action-shared [action]="createCommunityAction" />
  </ng-container>

  <unity-grid-community-shared />
</unity-page-container>
